import { FC, useEffect, useState } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";
import DiamondIcon from "assets/icons/diamond.svg?react";
import ArrowIcon from "assets/icons/banger/arrow-right.svg?react";
import url from "url/index";
import "./styles.sass";

type LoyaltyButtonProps = {
  isMini?: boolean;
  className?: string;
};

const LoyaltyButton: FC<LoyaltyButtonProps> = (props) => {
  const { isMini = false, className } = props;
  const [mini, setMini] = useState(isMini);
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  useEffect(() => {
    if (isMini) {
      setMini(isMini);
    } else if (!isMini) {
      setTimeout(() => {
        setMini(isMini);
      }, 300);
    }
  }, [isMini]);

  const navigate = useNavigate();

  const classNameRoot = classNames(
    "LoyaltyButton",
    mini && "LoyaltyButton_mini",
    className,
  );

  return (
    <div
      className={classNameRoot}
      onClick={() =>
        navigate(
          makeLangUrl(
            `${url.config.profile.root}/${url.config.profile.loyaltyProgram.root}`,
          ),
        )
      }
    >
      <DiamondIcon />
      {!mini && (
        <>
          {VITE_APP_PROJECT_NAME === "banger" ? "BANGER" : "GLORY"} CLUB
          <div>
            <ArrowIcon />
          </div>
        </>
      )}
    </div>
  );
};

export default LoyaltyButton;
